<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00028"><a class="calibre23" id="CHAPTER_III"></a>CHAPTER III.</h2>
<p class="center1"><strong class="calibre4">A CRUEL ACCUSATION.</strong></p>
<p class="calibre3">The attention of the spectators, including the club members, was so
entirely given to the finish of the famous race for the Railroad Cup,
that, for a few minutes Snyder Appleby was the sole occupant of the
dressing-room. When a group of the fellows, forming a sort of triumphal
escort to the victors, noisily entered it, they found him standing by his
machine. It was supported by two rests placed under its handle bars, and
he was gazing curiously at the big wheel, which he was slowly spinning
with one hand.</p>
<p class="calibre3">“Hello, ‘Cider’!” cried the first of the new-comers, “what’s up? Anything
the matter with your wheel?”</p>
<p class="calibre3">“I believe there is,” answered the ex-captain, in such a peculiar tone of
voice that it at once arrested attention. “I don’t know what is wrong, and
<span id="pgepubid00029" title="[Pg 17]"></span>I wouldn’t make an examination until some of you fellows came in. In a
case like this I believe in having plenty of witnesses and doing
everything openly.”</p>
<p class="calibre3">“What do you mean?” asked one of the group, whose noisy entrance was now
succeeded by a startled silence.</p>
<p class="calibre3">“Turn that wheel and you’ll see what I mean,” replied Snyder.</p>
<p class="calibre3">“Why, it turns as hard as though it were running on plain bearing that had
never been oiled!” exclaimed the member who had undertaken to turn the
wheel as requested.</p>
<p class="calibre3">“That’s just it, and I don’t think it’s very surprising that I failed to
win the race with a wheel in that condition, do you?”</p>
<p class="calibre3">“Indeed I do not. The only surprising thing is that you held the lead so
long as you did, and managed to come in third. I know I couldn’t have run
a single lap if I’d been on that wheel. What’s the matter with it? Wasn’t
it all right when you started?”</p>
<p class="calibre3">“I thought it was,” replied Snyder, “but I soon found that something was
wrong, and before I left<span id="pgepubid00030" title="[Pg 18]"></span>
the track it was all I could do to move it. Now,
I want you fellows to find out what the matter is.”</p>
<p class="calibre3">A few moments of animated discussion followed, while several of the
fellows made a careful examination of the bicycle.</p>
<p class="calibre3">“Great Scott!” exclaimed one; “what’s in this oil cup? It looks as though
it were choked with black sand.”</p>
<p class="calibre3">“It’s emery powder!” cried another, extracting a few grains of the black,
oil-soaked stuff on the point of a knife blade. “No wonder your wheel
won’t turn. How on earth did it get there?”</p>
<p class="calibre3">“That is what I would like to find out,” answered the owner of the
machine. “It certainly was not there when I left the club house; for I had
just gone over every part and assured myself that it was in perfect order.
Since then but two persons have touched it, and I am one of them. I don’t
think it likely that anybody will charge me with having done this thing,
seeing that my sole interest was to win the race, and that if I so nearly
succeeded with my wheel in this condition, I could easily have done so had
it been all right. Nothing could be more painful to me than to bring a
charge<span id="pgepubid00031" title="[Pg 19]"></span> against one who lives under the same roof that I do; but you all
know who had the greatest interest in having me lose this race. I think
you all know, too, that he is the only person besides myself who handled
my wheel immediately before it. The one whom I trusted to bring it here in
safety was sent off by this person on some frivolous errand at the last
moment. Then, neglecting other and important duties, he volunteered to get
the machine himself. He was gone before I had a chance to decline his
offer. That is all I have to say upon this most unpleasant subject, and I
should not have said so much had not my own reputation, both as a racing
man and a gentleman, been at stake. Now I place the whole affair in the
hands of the club, satisfied that they will do me justice.”</p>
<p class="calibre3">Rod Blake, seated on a camp-stool, with a heavy “sweater” thrown over his
shoulders, and slowly recovering from the exhaustion of the race, had
observed and listened to all this with a pained curiosity. He could not
believe any member of the club guilty of such a cowardly act. When Snyder
began to charge him with having committed it, his face became deadly pale,
and he gazed at his adopted<span id="pgepubid00032" title="[Pg 20]"></span> cousin with an expression akin to terror. As
the latter finished, the young captain sprang to his feet, exclaiming:</p>
<p class="calibre3">“Snyder Appleby, how dare you bring such an accusation against me? You
know I am incapable of doing such a thing! Your wheel was in perfect
condition when I delivered it to you, and you know it was.”</p>
<p class="calibre3">“I can easily believe that the fellow who would perform the act would be
equally ready to lie out of it,” replied Snyder.</p>
<p class="calibre3">“Do you mean that I lie?”</p>
<p class="calibre3">“That is about the size of it.”</p>
<p class="calibre3">This was more than the hot-tempered young athlete could bear; and almost
before the words were out of Snyder’s mouth, a blow delivered with all the
nervous force of Rodman’s right arm sent him staggering back. It would
have laid him on the floor, had not several of the fellows caught him in
their arms.</p>
<p class="calibre3">He was furious with rage, and would have sprung at Rodman had he not been
restrained. As it was, he hissed through his clinched teeth, “I’ll make
you suffer for this yet, see if I don’t.”</p>
<p class="calibre3"><span id="pgepubid00033" title="[Pg 21]"></span>Immediately after delivering the blow, Rod turned, without a word, and
began putting on his clothes. The fellows watched him in silence. A minute
later he was dressed, and stood in the doorway. Here he turned and said:</p>
<p class="calibre3">“I am going home, fellows, and I shall wait there just one hour for an
assurance that you have faith in me, and do not believe a word of this
horrible charge. If such a message, sent by the whole club, reaches me
within that time, I will undertake to prove my innocence. If it does not
come, then I cease, not only to be your captain, but a member of the
club.”</p>
<p class="calibre3"><span id="pgepubid00034" title="[Pg 22]"></span></p>
<div class="pg-boilerplate" id="calibre_pb_16"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?45e47e57